import { IconProps } from 'interfaces';
import COLOR from 'constants/color';

const Shield = ({
  fill = COLOR.GRAY['900'],
  className = 'w-4 h-4',
  styles
}: IconProps) => {
  return (
    <svg
      className={styles || className}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      preserveAspectRatio='xMidYMid meet'
    >
      <path
        d='M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z'
        stroke={fill}
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
        fill='none'
      />
    </svg>
  );
};

export default Shield;
